// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"612":"0ee2c0354b7d64f81624","924":"aa9adb52d5d7d19b4cf0"}[chunkId] + ".js";
};